import axios, { type AxiosInstance } from 'axios';
import axiosRetry from 'axios-retry';
import { useAuth0 } from '@auth0/auth0-vue';

export function getAuth0Instance() {
  return useAuth0();
}

export const apiClient: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  timeout: 35000
});

// export const apiClient2: AxiosInstance = axios.create({
//   baseURL: import.meta.env.VITE_API_BASE_URL_2,
//   withCredentials: false,
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'application/json'
//   },
//   timeout: 35000
// });

const applyCommonInterceptors = (
    client: AxiosInstance,
    getAccessToken?: () => Promise<string | null>
) => {
    client.interceptors.request.use(async (config) => {
        try {
            if (getAccessToken) {
                let token = null;
                let attempts = 0;
                while (!token && attempts < 10) {
                    token = await getAccessToken();
                    if (!token) {
                        await new Promise(resolve => setTimeout(resolve, 200));
                        attempts++;
                    }
                }
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
        } catch (e) {
            console.warn('Auth token not attached', e);
        }

        const locale = localStorage.getItem('locale') || 'en';
        config.headers['Accept-Language'] = locale;
        return config;
    });
};

applyCommonInterceptors(apiClient);


axiosRetry(apiClient, {
  retries: 3,
  retryDelay: (retryCount, error) => {
    const delay = axiosRetry.exponentialDelay(retryCount);
    return delay;
  },
  retryCondition: (error) => {
    const shouldRetry = axiosRetry.isNetworkOrIdempotentRequestError(error) || error.code === 'ECONNABORTED';
    return shouldRetry;
  }
});

apiClient.interceptors.response.use(null, (error) => {
  return Promise.reject(error);
});

export const utils = {
  formatDate : (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
};
export { applyCommonInterceptors };
